import React from 'react'
import useTrans from '@hooks/useTrans'
import { WImage } from '@components/atoms'
import ProdottoDetailCard from '../ProdottoDetailCard/ProdottoDetailCard'
import styles from './HeroModalSlide.module.sass'


interface Props {
  nomeCollezione?: string
  item?: any
  className?: string
}

const HeroModalSlide = (props: Props) => {

  const { 
    nomeCollezione = undefined,
    item = undefined,
    className = '',
  } = props

  const t = useTrans()

  return item ? (
    <div className={`${styles.root} ${className}`}>
      <div className={`${styles.imageBox} swiper-zoom-wrapper`}>
        <div className={'swiper-zoom-container'}>
          <WImage
            src={item.url}
            alt={item?.imageAlt}
            // title={TODO}
            maxWidth={715}
            maxHeight={560}
            objectFit="cover"
            priority
            loading="eager"
          />
        </div>
      </div>
      {item.articoliGallery?.length && (
        <div className={styles.main}>
          <div className={styles.content}>
            {!!nomeCollezione && <p className={styles.title}>{nomeCollezione}</p>}
            <p className={styles.description}>
              {t('In questa immagine trovi seguenti prodotti:')}
            </p>
          </div>
          <div className={styles.list}>
            {item.articoliGallery?.map((x) => (
              <ProdottoDetailCard item={x} key={x.pk} />
            ))}
          </div>
        </div>
      )}
    </div>
  ) : <></>
}

export default HeroModalSlide
